@if (showIe) {
  <div>
    <div class="ie-notification {{styleType}}" [ngClass]="">
      <!-- <span [ngClass]="iconClass">
    </span> -->
    <p class="ie-notification-text">
      {{ ieNotificationText }}
    </p>
    @if (showClose) {
      <span class="ie-notification-close" (click)="closeIeMessage()">
        &#10005;
      </span>
    }
  </div>
</div>
}